export class CurrentUser {
  Id: string;
  Name: string;
  Groups: Array<string>;
  CompanyName: string;
  CompanyCode: string;
  allowDelete: boolean;
  visibiltyPermissions: number;
  AllowEditGuestEndDate: boolean;
  incrementEndDateByOneDay: boolean;
  guestValidateIdentityNumber: boolean;
  permission: number;

  constructor(Id?: string,
              Name?: string,
              Groups?: Array<string>,
              CompanyName?: string,
              CompanyCode?: string,
              allowDelete?: boolean,
              visibiltyPermissions?: number,
              AllowEditGuestEndDate?: boolean,
              incrementEndDateByOneDay?: boolean,
    guestValidateIdentityNumber?: boolean,
    permission?: number) {
    this.Id = Id;
    this.Name = Name;
    this.Groups = Groups;
    this.CompanyName = CompanyName;
    this.CompanyCode = CompanyCode;
    this.allowDelete = allowDelete;
    this.visibiltyPermissions = visibiltyPermissions;
    this.AllowEditGuestEndDate = AllowEditGuestEndDate;
    this.incrementEndDateByOneDay = incrementEndDateByOneDay;
    this.guestValidateIdentityNumber = guestValidateIdentityNumber;
    this.permission = permission;
  }
}
